<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="SCM供应商出错情况数据 left_4"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
      :tooltipText="'供应商出错情况数据'"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div slot="main" style="height: 100%; position: relative">
        <div id="left_4" />
        <div
          class="iconfont icon-sanjiaoxing1 chart_icon_animation animation_rotateY-reverse"
        ></div>
      </div>
    </date-change-card>
  </div>
</template>

<script>
import {supplierError} from "@/api/cockpit/jyl"
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import {formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "left_4",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      date: new Date(),
      chart: null,
      chartData: [],
      totalNum: 0,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData() {

      //初始化数据
      this.totalNum = 0;
      this.chartData = [];

      //获取ERP数据
      supplierError(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        //处理数据
        if(resp.data){
          for (let key in resp.data) {
            this.totalNum += resp.data[key];
            this.chartData.push({value: resp.data[key], name: key })
          }
        }
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_4"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "2%",
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
        ],
        series: [
          {
            name: "SCM供应商出错情况数据",
            type: "pie",
            radius: ["30%", "48%"],
            top: "-10%",
            center: "center",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
            labelLine: {
              length: 5,
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  #left_4 {
    height: 100%;
  }
  .chart_icon_animation {
    position: absolute;
    left: 46%;
    top: 42%;
    font-size: 48px;
    color: #909399;
  }
}
</style>
